export const formatAsThousands = (val) =>
  Math.round(val)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const formatAsDollars = (val, options = {}) => {
  const plusSign = options.explicitPlus ? '+' : '';
  return (val < 0 ? '-' : val > 0 ? plusSign : '') + `$${formatAsThousands(Math.abs(val))}`;
};
